import { MovieOpenSettingsIcon } from './MovieOpenSettingsIcon';

/**
 * author: Colton Wiscombe
 * id FC6ECE54-744A-4A77-B032-897B24064048
 * name movie-open-settings
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/movie-open-settings.svg
 * tags
 * - Video / Movie 
 * - Settings 
 */
export const ClapperboardOpenSettingsIcon = MovieOpenSettingsIcon;
export default ClapperboardOpenSettingsIcon